import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  TextField
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";

function MdRequestAdditionalDocs({ state, dispatch }) {
  const { mdRequestAdditionalDocs } = state;
  const classes = useStyles();

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={!!mdRequestAdditionalDocs?.open}
      className={classes.dialog}
    >
      <DialogTitle>
        <div className="header">
          <div>Các chừng từ yêu cầu bổ sung</div>
          <CloseIcon
            onClick={() => dispatch("closeAddOriginalDocs")}
            style={{ cursor: "pointer" }}
          />
        </div>
      </DialogTitle>
      <DialogContent dividers style={{ padding: 24 }}>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={(mdRequestAdditionalDocs?.elements || []).includes(200)}
                onChange={() =>
                  dispatch({ type: "onChangeAddOriginalDocs", name: 200 })
                }
              />
            }
            key="200"
            label="Hình ảnh hàng hóa/ tài liệu trước khi bị sự cố"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={(mdRequestAdditionalDocs?.elements || []).includes(201)}
                onChange={() =>
                  dispatch({ type: "onChangeAddOriginalDocs", name: 201 })
                }
              />
            }
            key="201"
            label="Hình ảnh hàng hóa/ tài liệu sau khi bị sự cố"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={(mdRequestAdditionalDocs?.elements || []).includes(202)}
                onChange={() =>
                  dispatch({ type: "onChangeAddOriginalDocs", name: 202 })
                }
              />
            }
            key="202"
            label="Hình ảnh hóa đơn"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={(mdRequestAdditionalDocs?.elements || []).includes(204)}
                onChange={() =>
                  dispatch({ type: "onChangeAddOriginalDocs", name: 204 })
                }
              />
            }
            key="204"
            label="Hình ảnh chữ ký"
          />
        </FormGroup>

        <TextField
          fullWidth
          multiline
          rows={4}
          value={mdRequestAdditionalDocs?.note || ""}
          placeholder="Nhập ghi chú"
          style={{ margin: "15px 0 25px" }}
          onChange={(e) =>
            dispatch({
              type: "onChangeAddOriginalDocs",
              name: "note",
              value: e.target.value,
            })
          }
        />
        <div className="action">
          <Button
            className="btn"
            disabled={(mdRequestAdditionalDocs?.elements || []).length < 1}
            onClick={() =>
              dispatch({ type: "openConfirmOriginalDocs", open: true })
            }
          >
            Xác nhận
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default MdRequestAdditionalDocs;

const useStyles = makeStyles((theme) => ({
  dialog: {
    zIndex: theme.zIndex.drawer + 1,
    "& .MuiPaper-root.MuiPaper-elevation": {
      borderRadius: "12px",
      width: "100%",
      margin: 0,
    },

    "& .header": {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      fontWeight: 600,
      fontSize: 19,
    },

    "& .action": {
      display: "flex",
      justifyContent: "flex-end",
    },
    "& .btn": {
      width: "25%",
      padding: "4px 8px",
      borderRadius: 5,
      textTransform: "none",
      fontSize: 16,
      fontWeight: 500,
      color: "#fff",
      background: "#1A427D",
      border: "1px solid #3961A0",
      "&:hover": {
        color: "#fff",
        background: "#3961A0",
      },
    },
    "& .MuiOutlinedInput-root": { padding: "15px !important" },
    "& .Mui-disabled": {
      opacity: 0.3,
    },
    "& .Mui-checked": { color: "#3961A0" },
  },
}));
